export default (state, onlyScoped) => {
  state.onlyScoped = onlyScoped;
}



// WEBPACK FOOTER //
// ./src/app/store/templates/main/mutations/set-only-scoped.js